import { API } from "constants/envs";
import { encryptRSA } from "tools/encryption";
import { IPay } from "./props";

export const postCreateReference = async () => {
  const url = `${API}/mp/`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "*",
    },
  });

  const info = response.json();
  return info;
};

export const postProccessPayment = async (data: IPay) => {
  console.log(data);
  const url = `${API}/mp/process_payment`;
  const body = JSON.stringify({ payload: encryptRSA(JSON.stringify(data)) });

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "*",
    },
    body,
  });

  const info = response.json();
  return info;
};
